var _a;
import { __assign, __spreadArray } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxModuleLoaded, overrideSubscribeMatureFilter, } from './actions';
var reducers = handleActions((_a = {},
    _a[reduxModuleLoaded.toString()] = function (state, action) { return (__assign(__assign({}, state), { reduxReady: true })); },
    _a[overrideSubscribeMatureFilter.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { matureFilterOverrides: __spreadArray([
                payload.tier.deviationId
            ], state.matureFilterOverrides, true) }));
    },
    _a), {
    reduxReady: false,
    matureFilterOverrides: [],
});
export default reducers;
//# sourceMappingURL=reducer.js.map